import React, { useEffect, useCallback } from "react";
import { Outlet } from "react-router-dom";
//import { BaseSnackBarContext, useBaseSnackBar } from "@/shared/components/snack-bar/base-snack-bar-context";
//import { BaseSnackBar } from "@/shared/components/snack-bar/base-snack-bar";
import { BaseDisplayContext, useDisplayData } from "@/shared/context/base-display-context";

export const BaseRootLayout = () => {
  //const contextValueSnackBar = useBaseSnackBar();
  const contextValueDisplay = useDisplayData();

  const handleKeyDown = useCallback((e: KeyboardEvent) => {
    if (e.key !== "Tab") return;

    // モーダルや明細ビューが開いている場合はそちらのフォーカストラップに任せる
    if (document.getElementById("modal")) return;
    if (document.querySelector(".list-detail.active")) return;

    const root = document.getElementById("react-root");
    if (!root) return;

    const focusableElements = root.querySelectorAll<HTMLElement>(
      'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    if (focusableElements.length === 0) return;

    const first = focusableElements[0];
    const last = focusableElements[focusableElements.length - 1];

    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }, []);

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [handleKeyDown]);

  return (
    <BaseDisplayContext.Provider value={contextValueDisplay}>
      {/*<BaseSnackBarContext.Provider value={contextValueSnackBar}>*/}
        <Outlet />
        {/*<BaseSnackBar />*/}
      {/*</BaseSnackBarContext.Provider>*/}
    </BaseDisplayContext.Provider>
  );
};
